<template>
  <span><!-- placeholder --></span>
</template>

<script setup>
/**
 * Note: Forte.js from vendor is meant to be included as <script src=...> in an HTML page. It is not "exported."
 * So, it needs to be "loaded" as it cannot be "imported" via JavaScript directly.
 *
 * Also, the Forte library will NOT load in this component. Thus, it is preloaded in its parent (Payment).
 */
import {  watch } from 'vue';
import getForteConfig from './forteConfig';

// Define Props - using defineProps() compiler macro
const props = defineProps({
  cardNumber: {
    type: String,
    required: true,
  },
  cardMonth: {
    type: String,
    required: true,
  },
  cardYear: {
    type: String,
    required: true,
  },
  cardCvv: {
    type: String,
    required: true,
  },
  fetchToken: {
    type: Boolean,
    required: false,
    default: false,
  },
});

// Define Emits
const emit = defineEmits(['doPay']);

/**
 * Get one time token from Forte based on credit card info.
 */
const getOtt = async () => {
  setLoading(true);

  // credit card only
  const data = {
    api_login_id: getForteConfig().key,
    card_number: props.cardNumber, // Access props via the 'props' object
    expire_month: props.cardMonth,
    expire_year: props.cardYear,
    cvv: props.cardCvv,
  };

  // forte doesn't have a .finally event
  // eslint-disable-next-line
  forte.createToken(data)
      .success(ottSuccess)
      .error(ottError);
};

/**
 * Get OTT from Forte. (But it does not necessarily mean the OTT is good for payment, e.g. Forte still
 * return OTT with success status even if user inputs an unsupported credit card.)
 * @param res
 * @returns {Promise<void>}
 */
const ottSuccess = (res) => {
  setLoading(false);
  emit('doPay', { // Emit events via the 'emit' function
    hasOtt: true,
    forte: res,
  });
};

/**
 * Cannot get OTT.
 * @param res
 */
const ottError = (res) => {
  setLoading(false);
  emit('doPay', { // Emit events via the 'emit' function
    hasOtt: false,
    forte: res,
  });
};

const setLoading = (loading) => {
  console.log(loading);
};

// Watcher definition
watch(
  () => props.fetchToken, // Watch the prop value directly
  (newVal) => {
    if (newVal) {
      getOtt();
    }
  }
);
</script>